module.exports = __webpack_public_path__ + "depend.2vrA-IJt.jpg";